import React, { lazy, Suspense, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import * as links from "./constants/url";
import "./App.css";
import { DefaultLayout } from "./layout";

const Main = lazy(() =>
  import("./pages/Main/Main").then((module) => ({ default: module.Main }))
);
const Registration = lazy(() =>
  import("./pages/Registration/Registration").then((module) => ({
    default: module.Registration,
  }))
);
const PrivacyPolicy = lazy(() =>
  import("./pages/PrivacyPolicy/PrivacyPolicy").then((module) => ({
    default: module.PrivacyPolicy,
  }))
);
const Questionnaire = lazy(() =>
  import("./pages/Questionnaire/Questionnaire").then((module) => ({
    default: module.Questionnaire,
  }))
);
const QuestionnaireResult = lazy(() =>
  import("./pages/Questionnaire/QuestionnaireResult").then((module) => ({
    default: module.QuestionnaireResult,
  }))
);
const Home = lazy(() =>
  import("./pages/Home/Home").then((module) => ({ default: module.Home }))
);
const ProfileUpdate = lazy(() =>
  import("./pages/ProfileUpdate/ProfileUpdate").then((module) => ({
    default: module.ProfileUpdate,
  }))
);
const SelectTaskCategory = lazy(() =>
  import("./pages/Task/SelectTaskCategory").then((module) => ({
    default: module.SelectTaskCategory,
  }))
);
const Achievements = lazy(() =>
  import("./pages/Achievements/Achievements").then((module) => ({
    default: module.Achievements,
  }))
);
const AfterQuestionnaire = lazy(() =>
  import("./pages/Questionnaire/AfterQuestionnaire").then((module) => ({
    default: module.AfterQuestionnaire,
  }))
);
const Task = lazy(() =>
  import("./pages/Task/Task").then((module) => ({ default: module.Task }))
);
const ResultTask = lazy(() =>
  import("./pages/Task/ResultTask").then((module) => ({
    default: module.ResultTask,
  }))
);
const ResultCompleteCategory = lazy(() =>
  import("./pages/Task/ResultCompleteCategory").then((module) => ({
    default: module.ResultCompleteCategory,
  }))
);
const FullPercent = lazy(() =>
  import("./pages/Task/FullPercent").then((module) => ({
    default: module.FullPercent,
  }))
);
const Profile = lazy(() =>
  import("./pages/Profile/Profile").then((module) => ({
    default: module.Profile,
  }))
);

function App() {
  useEffect(() => {
    if (window.Telegram?.WebApp) {
      window.Telegram.WebApp.ready(() => {
        window.Telegram.WebApp.expand();
        const height =
          window.Telegram.WebApp.viewportHeight || window.innerHeight;
        document.body.style.minHeight = height + "px";
        document.body.style.overflowY = "auto";
      });
    }
  }, []);

  if (
    !(
      window.Telegram?.WebApp?.initData &&
      window.Telegram.WebApp.initData.length > 0
    ) &&
    process.env.REACT_APP_MODE !== "develop"
  ) {
    window.location.href = "https://t.me/Energy_100_bot";
    return null;
  }

  return (
    <Router>
      <Suspense fallback={<div className="loading_screen"></div>}>
        <Routes>
          <Route path={links.MAIN.url} element={<DefaultLayout />}>
            <Route index element={<Main />} />
            <Route path={links.REGISTRATION.url} element={<Registration />} />
            <Route
              path={links.PRIVACY_POLICY.url}
              element={<PrivacyPolicy />}
            />
            <Route path={links.QUESTIONNAIRE.url} element={<Questionnaire />} />
            <Route
              path={links.QUESTIONNAIRE_RESULT.url}
              element={<QuestionnaireResult />}
            />
            <Route
              path={links.AFTER_QUESTIONNAIRE.url}
              element={<AfterQuestionnaire />}
            />
            <Route path={links.HOME.url} element={<Home />} />
            <Route
              path={links.PROFILE_UPDATE.url}
              element={<ProfileUpdate />}
            />
            <Route
              path={links.SELECT_TASK_CATEGORY.url}
              element={<SelectTaskCategory />}
            />
            <Route path={links.TASK.url} element={<Task />} />
            <Route path={links.TASK_ID.url} element={<Task />} />
            <Route
              path={links.RESULT_AFTER_TASK.url}
              element={<ResultTask />}
            />
            <Route
              path={links.RESULT_AFTER_COMPLETE_CATEGORY.url}
              element={<ResultCompleteCategory />}
            />
            <Route
              path={links.PERCENT_100_AND_200.url}
              element={<FullPercent />}
            />
            <Route path={links.PROFILE.url} element={<Profile />} />
            <Route path={links.ACHIEVEMENTS.url} element={<Achievements />} />
          </Route>
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
